// CSS imports of icons (webp vs png) rely on this check, though it's not used in JS code
export async function initializeWebpCheck(): Promise<void> {
    const isWebSupported = await isAlphaWebpSupported();
    window.document.body.classList.add(isWebSupported ? 'webp' : 'no-webp');
}

function isWebpFeatureSupported(feature: 'lossy' | 'lossless' | 'alpha' | 'animation'): Promise<boolean> {
    const kTestImages = {
        lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
        lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
        alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
        animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
    };

    const img = new Image();
    return new Promise<boolean>((resolve) => {
        img.onload = function () {
            resolve(img.width > 0 && img.height > 0);
        };

        img.onerror = function () {
            resolve(false);
        };

        img.src = 'data:image/webp;base64,' + kTestImages[feature];
    });
}

function isAlphaWebpSupported(): Promise<boolean> {
    return isWebpFeatureSupported('alpha');
}
